import { createSlice } from "@reduxjs/toolkit";

export const initialStateForWishlistSlice = {
    wishlistList:[],
    wishlistInfluncers:[],
    draftCampaigns:[],
    showIconHighlitedForInfluncers:[],
    selectedWishlist:{
        id: null,
        color: "",
        name: "",
        platform: "",
        brandId: null,
        created_at: "",
        brandName: "",
        brandImage: "",
        influencersCount: 0,
},
}

const wishlistSlice = createSlice({
    name:'wishlist',
    initialState:initialStateForWishlistSlice,
    reducers: {
    updateWishlist : (state,action)=>{
    return {...state,...action.payload};
    },
    updateSelectedWishlistCount : (state,action)=>{
return {...state,selectedWishlist:{
    ...state.selectedWishlist,influencersCount:action.payload.count + state.selectedWishlist.influencersCount
}}
    },
        updateSelectedWishlistCountIfDeleteApiGotError: (state, action) => {
            return {
                ...state, selectedWishlist: {
                    ...state.selectedWishlist, influencersCount: state.selectedWishlist.influencersCount + action.payload.count
                }
            }
    },
        rollbackSelectedWishlistCount : (state,action)=>{
return {...state,selectedWishlist:{
    ...state.selectedWishlist,influencersCount:state.selectedWishlist.influencersCount - action.payload.count
}}
    },
}
})


export const {updateWishlist,updateSelectedWishlistCount,rollbackSelectedWishlistCount,updateSelectedWishlistCountIfDeleteApiGotError} = wishlistSlice.actions;
export default wishlistSlice.reducer;
